import { render } from "./Patient.vue?vue&type=template&id=1aa20634"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"
script.render = render

export default script